import { of } from 'rxjs';
import { FloorPlan } from './../model/floorplan.model';
import { DictToJSON } from './../model/dictionary.model';
import { environment } from './../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Dictionary } from '../model/dictionary.model';
import { LoaderService } from './loader.service';
import { sanitizeCodEnte, sanitizeFilenameStem, sanitizeTextInput } from '../shared/utils';

@Injectable({
    providedIn: 'root',
})
export class MiddlewareService {

    baseUrl: string;
    codEnte: string;

    constructor(
        private http: HttpClient
    ) { 
        this.baseUrl = environment.apiUrl;
    }

    checkCodEnte() {
        if (!this.codEnte) {
            this.codEnte = sanitizeCodEnte(localStorage.getItem('cod_ente'));
        }
    }

    private buildHeaders() {
        const headersObject = this.codEnte ? { 'cod_ente': this.codEnte } : {};
        return new HttpHeaders(headersObject);
    }

    getDictionary() {
        this.checkCodEnte();
        const headers = this.buildHeaders();
        return this.http.get(this.baseUrl + '/plan/get/dizionario', {headers: headers});
    }

    getFloorPlan(filename: string) {
        this.checkCodEnte();
        const headers = this.buildHeaders();
        const safeFilename = sanitizeFilenameStem(filename);
        return this.http.get(this.baseUrl + `/plan/get/file/json/${encodeURIComponent(safeFilename || '')}.json`, {headers: headers});
    }

    getPng(filename: string) {
        this.checkCodEnte();
        const headers = this.buildHeaders();
        const safeFilename = sanitizeFilenameStem(filename);
        return this.http.get(this.baseUrl + `/plan/get/file/png/${encodeURIComponent((safeFilename || '') + '.png')}`, {headers: headers, responseType: 'arraybuffer'});
    }

    putFloorPlan(plan: FloorPlan) {
        this.checkCodEnte();
        const headers = this.buildHeaders();
        const jsonString = this.planToJSON(plan);
        var blob = new Blob([jsonString], {type: "application/json"});
        const safeName = sanitizeFilenameStem(plan.testata.nome_file) || 'plan';
        const f = new File([blob], safeName + '.json', {type: "application/json"});
        const formData = new FormData();
        formData.append('file', f, safeName + '.json');
        return this.http.post(this.baseUrl + '/plan/put/file', formData, {headers: headers});
    }

    putDictionary(dict: Dictionary[]) {
        this.checkCodEnte();
        const headers = this.buildHeaders();
        const jsonString = this.dictionaryToJSON(dict);
        console.log(this.dictionaryToJSON(dict));
        var blob = new Blob([jsonString], {type: "application/json"});
        const f = new File([blob], 'dict.json', {type: "application/json"});
        const formData = new FormData();
        formData.append('file', f, 'dict.json');
        return this.http.post(this.baseUrl + '/plan/put/dizionario', formData, {headers: headers});
    }

    dictionaryToJSON(dict: Dictionary[]) {
        const json = []
        dict.forEach(val => {
            const obj = {
                'DESTINAZIONE PLANIMETRIA': sanitizeTextInput(val.destinazionePlanimetria, 128),
                'DESTINAZIONE NORMALIZZATA': sanitizeTextInput(val.destinazioneNormalizzata, 128),
                'MACROGRUPPO': sanitizeTextInput(val.macrogruppo, 128),
                'COEFFICIENTE CALCOLO SUP TARI': val.coefficienteCalcoloSupTari
            };
            json.push(obj);
        });
        return JSON.stringify(json);
    }

    planToJSON(plan: FloorPlan) {
        const testata = plan.testata;
        const poligono = plan.poligono;
        let rooms_ok: number = 0;
        let rooms_blank: number = 0;
        let rooms_unk: number = 0;

        poligono.forEach(val => {
            if (val.rooms && val.rooms[0]) {
                if (val.normalized && val.normalized[0]) {
                    rooms_ok++;
                } else if (!val.normalized || (val.normalized && !val.normalized[0])) {
                    rooms_unk++;
                }
            } else if (!val.rooms || (val.rooms && !val.rooms[0])) {
                rooms_blank++;
            }
        });

        const json = {
            "testata": 
                {
                    "nome file": sanitizeFilenameStem(testata.nome_file) || '',
                    "formato foglio": testata.formato_foglio,
                    "scala": testata.scala,
                    "formato immagine": testata.formato_immagine,
                    "docfa": testata.docfa,
                    "rooms_ok": rooms_ok,
                    "rooms_blank": rooms_blank,
                    "rooms_unk": rooms_unk,
                    "privateKey": testata.privateKey ? sanitizeTextInput(testata.privateKey.toString(), 256) : '',
                    "codice ente": sanitizeCodEnte(testata.cod_ente ? testata.cod_ente : this.codEnte) || '',
                    "error": '',
                    "created_by": "PLANI"
                }
            ,
            "poligono": []
        };

        poligono.forEach(val => {
            json.poligono.push({
                "rooms": (val.rooms || []).map((room) => sanitizeTextInput(room, 128)),
                "normalized": (val.normalized || []).map((normalized) => sanitizeTextInput(normalized, 128)),
                "macro": (val.macro || []).map((macro) => sanitizeTextInput(macro, 128)),
                "tari_coeff": val.tari_coeff,
                "area": val.area,
                "x": val.x,
                "y": val.y,
                "alerts": [],
                "contour": val.contour
            });
        });
        return JSON.stringify(json);
    }
}